import { createAppModule } from "../api/appModuleService";

export const useCreateModule = (successCallback) => {
    const create = async (data) => {
        try {
            const newRecord = await createAppModule(data);
            if (successCallback) successCallback();
            return newRecord;
        } catch (error) {
            console.error("Failed to create app module:", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { create };
};